import { configureStore } from '@reduxjs/toolkit';
import { adminReducer } from './slices/admin/slice';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { setAuthHeader } from 'api';

const adminConfig = {
  key: 'admin',
  storage,
  whitelist: ['token', 'isLoggedIn'],
};

export const store = configureStore({
  reducer: {
    admin: persistReducer(adminConfig, adminReducer),
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

let currentToken = store.getState().admin?.token ?? null;
setAuthHeader(currentToken);

store.subscribe(() => {
  const nextToken = store.getState().admin?.token ?? null;
  if (nextToken !== currentToken) {
    currentToken = nextToken;
    setAuthHeader(currentToken);
  }
});

export const persistor = persistStore(store);
